import { gql } from "apollo-angular";
import { CBFF } from "./content-block-full";

export const  LTCF = gql`
  fragment LTCF on Large2Column {
    sys {
      id
    }
    isPzd
    backgroundColor {
      color
    }
    headerAlignment
    header
    headerTag
    hTagId
    content
    columnAlignment
    column1Content {
      ...CBFF
    }
    column2Content {
      ...CBFF
    }
    disclaimer {
      ... on DisclaimerItem {
        disclaimer
      }
    }
}
${CBFF}`;
